<template>
  <button
    type="submit"
    class="sign-in_button"
    :disabled="disabled">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean
  }
};
</script>

<style scoped>
.sign-in_button {
  outline: 0;
  background-color: rgb(52, 174, 196);
  text-align: center;
  color: #fff;
  width: 100%;
  line-height: 36px;
  border-radius: 4px;
  font-weight: 600;
}
.sign-in_button:disabled {
  opacity: 0.3;
}
</style>